import React, { Component } from "react"
import { connect } from "react-redux"
import { SaleAttributionService, GroupPositionUserService, buildTransaction } from "../normalizer"
import { ToastService } from "../../Gamification2026Template/shared/Toast"

class UpdateAttributionContainer extends Component {
  state = {
    user: undefined,
    groupUsers: []
  }

  payload = () => ({
    campaignSlug: this.props.campaign.slug,
    clientSlug: this.props.user.client.slug
  })

  handleSubmit = async () => {
    const { attribution, onClose, onSuccess } = this.props
    try {
      await SaleAttributionService.updateSaleAttribution({
        ...this.payload(),
        id: attribution && attribution.id,
        userId: this.state.user.id
      })
      // onSuccess is preferred when provided (e.g. to trigger a list refresh);
      // fall back to onClose for backward-compatibility with other callers.
      if (onSuccess) onSuccess()
      else if (onClose) onClose()
    } catch (error) {
      ToastService.error(error.response.data.error)
    }
  }

  handleUserChange = value => {
    this.setState({ user: value })
  }

  async fetchGroupUsers() {
    try {
      const response = await GroupPositionUserService.getGroupUsers(this.payload())
      this.setState({ groupUsers: response.data.users })
    } catch (error) {
      ToastService.error(error.response.data.error)
    }
  }

  componentDidMount() {
    this.fetchGroupUsers()
  }

  render() {
    const { component: Component, ...rest } = this.props

    return (
      <Component
        {...rest}
        users={this.state.groupUsers}
        onUserChange={this.handleUserChange}
        selectedUser={this.state.user}
        onSubmit={this.handleSubmit}
      />
    )
  }
}

const mapStateToProps = state => ({
  user: state.userReducer.user,
  campaign: state.campaignReducer.campaign
})

const mapDispatchToProps = dispatch => ({
  startTransaction: buildTransaction(dispatch)
})

const Container = connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateAttributionContainer)

export function withUpdateAttributionContainer(component) {
  return (props) => (
    <Container
      component={component}
      {...props}
    />
  )
}

export default Container
